module.exports = __webpack_public_path__ + "assets/img/00049.93f52f28.png";